var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.775L8.10005 14.675C7.91672 14.8583 7.68338 14.95 7.40005 14.95C7.11672 14.95 6.88338 14.8583 6.70005 14.675C6.51672 14.4917 6.42505 14.2583 6.42505 13.975C6.42505 13.6917 6.51672 13.4583 6.70005 13.275L11.3 8.675C11.4 8.575 11.5084 8.50417 11.625 8.4625C11.7417 8.42083 11.8667 8.4 12 8.4C12.1334 8.4 12.2584 8.42083 12.375 8.4625C12.4917 8.50417 12.6 8.575 12.7 8.675L17.3 13.275C17.4834 13.4583 17.575 13.6917 17.575 13.975C17.575 14.2583 17.4834 14.4917 17.3 14.675C17.1167 14.8583 16.8834 14.95 16.6 14.95C16.3167 14.95 16.0834 14.8583 15.9 14.675L12 10.775Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/Chevron_up.b14ece8c09cd6e1676bc0e2d1730d1fa.svg";
export { ForwardRef as ReactComponent };